import { Avatar as MuiAvatar, type SxProps } from '@mui/material';
import { type AvatarInfo } from '@/types';
import { getInitials } from './utils';

type Props = {
  sx?: SxProps;
  user?: AvatarInfo;
};

const Avatar = ({ sx, user }: Props) => {
  const { full_name = '', avatar = '' } = user || {};
  const initials = getInitials(full_name);

  return (
    <MuiAvatar sx={sx} src={avatar ?? undefined}>
      {initials}
    </MuiAvatar>
  );
};

export default Avatar;
